import { useEffect } from "react";
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI } from "../utils/fetchData";

export default function VerifyEmail() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

		trackPromise(
			getDataAPI(
				`emailVerification/${window.location.pathname.split("/")[2]}`,
				window.location.pathname.split("/")[2]
			)
				.then((res) => {
					console.log("res getcoursecategory", res.data);

					if (res.status === 200) {
						dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
						alert(res.data.msg);
						dispatch({
							type: GLOBALTYPES.AUTH,
							payload: { token: res.data.access_token, user: res.data.user },
						});

						dispatch({
							type: GLOBALTYPES.USER_TYPE,
							payload: res.data.user.role,
						});

						localStorage.setItem("firstLogin", true);
						localStorage.setItem("access_token", res.data.access_token);

						window.location.href =
							"/courses/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af";
					} else {
						alert("Link expired!!!");
					}
				})
				.catch((err) => {
					alert("Link expired");
					console.log(err);
					window.close();
				})
		);
	}, []);

	return (
		<>
			{/* <Navbar /> */}

			{/* <Footer /> */}
		</>
	);
}
